import { NibbleActionHandler } from '../nibble-action.handler';

export class ServiceHandlerMap {
  private map: {
    [key: string]: NibbleActionHandler;
  } = {};

  add(service: string, nibbleActionHandler: NibbleActionHandler) {
    this.map[service] = nibbleActionHandler;
  }

  get(service: string): NibbleActionHandler {
    return this.map[service];
  }
}
